module.exports = __webpack_public_path__ + "img/8.a2703b85.png";